import { useTranslation } from 'react-i18next';
// import type React from 'react';
import useFundContext from '@/contexts/Fund/useFundContext';
import styles from '../SupportGoalsPage.module.scss';
// import Tile, { TileIcon, TileLabel, TileList, TileListItem } from '@/components/ui/Tile/Tile';
import { TileList, TileListItem } from '@/components/ui/Tile/Tile';

// Icons
import IconsToGoals from '@/maps/IconsToGoals';
import type { GoalDtoIn } from '@/models/in/GoalDtoIn';
// import addGoal from '@/assets/icons/supportGoals/add-goal.svg';

type GoalsSectionProps = {
  title: string;
  goals: GoalDtoIn[];
  isLoading?: boolean;
  onSelectGoal?: (goal: GoalDtoIn | null) => void;
  selectedGoalId?: number;
  /** Extra tile rendered after the goals (the projects entry point on the fund-expense section). */
  extraTile?: React.ReactNode;
  /** Tile rendered before the goals. */
  leadingTile?: React.ReactNode;
};

const GoalsSection = ({ title, goals, isLoading = false, onSelectGoal, selectedGoalId, extraTile, leadingTile }: GoalsSectionProps) => {
  const { currentFund } = useFundContext();
  const { t } = useTranslation();

  const goalsTilesData: TileListItem[] = (goals ?? []).map((g) => ({
    id: g.id,
    label: t(g.name),
    icon: IconsToGoals[g.name] ?? undefined,
    subLabel: t(g.description) || undefined,
    onClick: () => onSelectGoal?.(g),
  }));
  

  if (!currentFund) return <h1>{t('noFundSelected')}.</h1>;

  if (isLoading) {
    return (
      <div className={styles.section}>
        <h1 className={styles.headerTitle}>{t(title)}</h1>
        <p>{t('loading')}</p>
      </div>
    );
  }

  // With no goals but an extra tile to show, the section still has content - only fall back to
  // the empty message when there is genuinely nothing to render.
  if (goalsTilesData.length === 0 && !extraTile && !leadingTile) {
    return (
      <div className={styles.section}>
        <h1 className={styles.headerTitle}>{t(title)}</h1>
        <p>{t('noGoalsAvailable')}</p>
      </div>
    );
  }

  return (
    <div className={styles.section}>
        <h1 className={styles.headerTitle}>{t(title)}</h1>
        <TileList
          tiles={goalsTilesData}
          selectedId={selectedGoalId}
          additionalTiles={extraTile}
          leadingTiles={leadingTile}
        />
    </div>
  );
};

export default GoalsSection;
